import { EmptyState } from '@boogbe/ui';

export function NotFound() {
  return (
    <main className="p-8">
      <EmptyState title="Page not found" />
    </main>
  );
}
